import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { PAYMENT_INTERVAL } from './index';
export function SubscriptionTabs({ planInterval, onIntervalChange }) {
    return (<div className="payment-setup__subscription__tabs">
      <div className="payment-setup__button-toggle-container button-toggle">
        <div className={classNames('payment-setup__button-container-annual', {
            'payment-setup__button-container-annual--disabled': planInterval !== PAYMENT_INTERVAL.ANNUAL,
        })}>
          <a onClick={() => onIntervalChange(PAYMENT_INTERVAL.ANNUAL)}>
            <FormattedMessage id="auth.payment-setup.annualSave16Percent"/>
          </a>
        </div>

        <div className={classNames('payment-setup__button-container-monthly', {
            'payment-setup__button-container-monthly--disabled': planInterval !== PAYMENT_INTERVAL.MONTHLY,
        })}>
          <a onClick={() => onIntervalChange(PAYMENT_INTERVAL.MONTHLY)}>
            <FormattedMessage id="auth.payment-setup.monthly"/>
          </a>
        </div>
      </div>
    </div>);
}
